import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=6a01a3bb&scoped=true"
import script from "./ChangePassword.vue?vue&type=script&lang=js"
export * from "./ChangePassword.vue?vue&type=script&lang=js"
import style0 from "./ChangePassword.vue?vue&type=style&index=0&id=6a01a3bb&prod&scoped=true&lang=css"
import style1 from "./ChangePassword.vue?vue&type=style&index=1&id=6a01a3bb&prod&lang=css"
import style2 from "spinkit/scss/spinkit.scss?vue&type=style&index=2&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a01a3bb",
  null
  
)

export default component.exports